import Top100ItemsState from "@galarson/Store/Top100Items/Top100ItemsState";
import {
    ApiParameter,
    get
} from "@insite/client-framework/Services/ApiService";

export interface GetTop100ItemsApiParameter extends ApiParameter {
    sort: string;
    customerNumber: string; 
}

const top100ItemsUrl = "/api/v1/top100itemsextensions/";

export async function getTop100Items(parameter: GetTop100ItemsApiParameter): Promise<Top100ItemsState> {
    // can't send empty status array to API
    const customerNumber = parameter.customerNumber;
    delete (parameter as any).customerNumber;
    const top100Items = await get<Top100ItemsState>(top100ItemsUrl+customerNumber, parameter);
    return top100Items;
}
